import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, KeyRound } from "lucide-react";
import { getSiteConfig } from "@/siteConfig";

export default function DownloadCTA() {
    const { version, supportEmail } = getSiteConfig();
    return (
        <section
            data-testid="download-section"
            className="border-b border-border blueprint-bg"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
                <div className="bg-bg border border-ink shadow-[12px_12px_0_0_hsl(var(--ink))] p-8 md:p-12 lg:p-16 grid lg:grid-cols-12 gap-10 items-end">
                    <div className="lg:col-span-7">
                        <span className="overline">Customer download</span>
                        <h2 className="font-display text-3xl md:text-4xl lg:text-6xl font-black tracking-tighter mt-4 leading-[0.95] text-ink">
                            Sign in to install.
                            <br />
                            Run your first search in 5 minutes.
                        </h2>
                        <p className="mt-6 text-ink-soft max-w-xl">
                            The Windows installer for v{version} is available
                            inside the customer dashboard after registration or
                            purchase. Requires your own Google Places API key
                            and SMTP provider.
                        </p>
                    </div>
                    <div className="lg:col-span-5 flex flex-col gap-3">
                        <Link
                            data-testid="download-cta-primary"
                            to="/register"
                            className="btn btn-accent w-full h-14"
                        >
                            Create account <ArrowUpRight size={14} />
                        </Link>
                        <Link
                            data-testid="download-cta-signin"
                            to="/login"
                            className="btn btn-primary w-full h-14"
                        >
                            <KeyRound size={16} />
                            Sign in to download
                        </Link>
                        <a
                            data-testid="download-cta-help"
                            href={`mailto:${supportEmail}?subject=ReachForge%20download%20support`}
                            className="btn btn-secondary w-full h-14"
                        >
                            Ask for help <ArrowUpRight size={14} />
                        </a>
                        <ul className="mt-4 font-mono text-[11px] uppercase tracking-[0.18em] text-ink-mute space-y-2">
                            <li>· Installer available after sign-in</li>
                            <li>· Your own Google Places API key</li>
                            <li>· Your own SMTP provider</li>
                            <li>· Active ReachForge licence key</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
